import React, { useState } from 'react';
import style from './style.module.scss';
import ReactModal from 'react-modal';
import TextInput from '../../../../components/form/text-input';
import ButtonIcon from '../../../../components/ButtonIcon/ButtonIcon';
import { copyApp } from '../../../../../api';
import config from '../../../../../config';
import toast from 'react-hot-toast';
const MAIN_URL = config.paymentcloud.MAIN_URL

const CopyApplication = ({ isOpen, onClose, appData, loggedInUser, fetchApplication = null }) => {
  const [dbaName, setDbaName] = useState(appData?.field_dba ? appData?.field_dba : "");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    const payload = {
      id: appData?.id,
      stratus: true,
      ajaxRequest: true,
      new_dba: dbaName
    }
    setIsLoading(true);
    const toastId = toast.loading('Copying application...');
    const response = await copyApp(payload);

    if (response.status) {
      let redirect_url = `${MAIN_URL}${response.organization_slug}/${response.user_slug}/${response.data}/`;
      if (loggedInUser?.channel == "sales_channel") {
        redirect_url = `${MAIN_URL}${response.user_slug}/${response.data}/`;
      }
      toast.success('Application copied successfully!', { id: toastId });
      if (typeof fetchApplication === 'function') {
        fetchApplication();
      }
      setIsLoading(false);
      window.open(redirect_url, '_blank');
      onClose();
    } else {
      toast.error('Something went wrong!', { id: toastId });
    }
  }

  return (
    <ReactModal isOpen={isOpen} className={style.react_modal} ariaHideApp={false}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L6.93934 8L3.21967 11.7197C2.92678 12.0126 2.92678 12.4874 3.21967 12.7803C3.51256 13.0732 3.98744 13.0732 4.28033 12.7803L8 9.06066L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L9.06066 8L12.7803 4.28033C13.0732 3.98744 13.0732 3.51256 12.7803 3.21967C12.4874 2.92678 12.0126 2.92678 11.7197 3.21967L8 6.93934L4.28033 3.21967Z"
              fill="#737278"
            />
          </svg>
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Copy Application</h6>

        <div className={style.form_group}>
          <TextInput
            id="dba"
            name="dba"
            label="DBA"
            value={dbaName}
            onChange={(e) => setDbaName(e.target.value)}
            placeholder="Enter DBA"
          />
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor="#4C70EF"
            textColor="#FFF"
            isLoading={isLoading}
            disabled={!dbaName}
            onClick={handleSubmit}
          >
            Copy
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  )
}

export default CopyApplication;